export default function NoAccess(props) {
  return (
    <div>
      <h1>No access</h1>
      <p>You have no access to this resource</p>
    </div>
  )
}